export default __webpack_public_path__ + "static/media/lofty-logo.99b1b10a.svg";